// lib/config/locale.ts
//
// Centralised locale + timezone constants for fowlboys-ops. All formatters
// across the app should reference these instead of inline string literals.
//
// Convention:
//   - Numbers / currencies use en-MY (Malaysian English) - produces "RM 311,214.50".
//   - Dates use en-GB (British English) - produces "4 May 2026" rather than the
//     ambiguous en-MY "4/5/2026" (DD/MM vs MM/DD reads).
//   - Timezone is locked to Asia/Kuala_Lumpur (MYT) - Fowlboys is MYT-only ops.

export const LOCALE_NUMBER = "en-MY" as const;
export const LOCALE_DATE = "en-GB" as const;
export const TZ = "Asia/Kuala_Lumpur" as const;
